import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-search",
  "use": "icon-ib-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-search\"><path d=\"M128 488.021333a360.021333 360.021333 0 1 1 630.954667 237.013334l130.005333 130.005333a23.978667 23.978667 0 1 1-33.92 33.92l-130.005333-130.005333A360.021333 360.021333 0 0 1 128 488.021333z m360.021333-312.021333a312.021333 312.021333 0 1 0 0 624 312.021333 312.021333 0 0 0 0-624z\" p-id=\"5682\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol